module.exports = __webpack_public_path__ + "static/media/devconnector.6823ded2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/devconnector.png
// module id = 78
// module chunks = 0